import ApplicationAdapter from "./application";

export default class BlockStorageVolumeAdapter extends ApplicationAdapter {
  urlForCreateRecord() {
    return `${this.apiBaseUri}/blockstorage/create`;
  }

  urlForFindRecord(id) {
    return `${this.apiBaseUri}/blockstorage/details?volumeid=${id}`;
  }

  urlForUpdateRecord(id) {
    return `${this.apiBaseUri}/blockstorage/edit?volumeid=${id}`;
  }

  urlForDeleteRecord(id) {
    return `${this.apiBaseUri}/blockstorage/delete?volumeid=${id}`;
  }
}
